import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronCashBiz } from "sections";
import { LinkButton } from "components/buttons";

function AlrajhiCashBiz() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronCashBiz
          badgeText="Cash Management"
          title={`alrajhicashbiz
              <span className="jumbotron-subtitle-2">
                @24seven
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Account Management</div>
                <div className="column-subheader">
                  Gain a fish-eye-view of all your corporate banking accounts.
                  Easily track the inflows and outflows of funds.{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Payables Management</div>
                <div className="column-subheader">
                  Initiate payments (e.g. salary/vendor/supplier payments)
                  automatically over the Internet at your convenience{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Foreign Remittance</div>
                <div className="column-subheader">
                  Provide convenience to transfer fund abroad securely{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Liquidity Management</div>
                <div className="column-subheader">
                  Manage your accounts through pooling and auto-sweeping.{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Cash flow management is essential to business survival and
              success. alrajhi bank Malaysia helps you stay on top of your
              company's cash flow from wherever you operate. By taking care of
              this area of major concern, you can focus on strategising new
              ideas for business growth.
            </p>
            <p>
              Our cash management product lets you collect payments quicker,
              automate regular payments to suppliers, vendors and employees, and
              keep a close tab of your accounts and balances. Via the Internet,
              you can exercise complete control over incoming and outgoing
              funds, and know the current status of your account in an instant.
              It's the best way to exercise full control over your company's
              cash flow.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">Collections </div>
                <div className="column-subheader-2">
                  Coordinate the collection of regular payments from your
                  customers. Facilitate wholesale and retail cheque collections.
                  Directly debit funds from your customer's or dealer's alrajhi
                  bank Malaysia accounts.{" "}
                </div>
              </div>
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">Online Advice</div>
                <div className="column-subheader-2">
                  Send automatic reminders via email for authorisers to
                  authorise transactions. Beneficiaries will also be sent an
                  advice via email for any successful or rejected
                  payments/collections.{" "}
                </div>
              </div>
              <div className=" col-12 custom-column-2">
                <div className="column-header-2">Security</div>
                <div className="column-subheader-2">
                  Only the latest encryption methods and strictest security
                  practices for safe access to your financial information{" "}
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">Shariah Compliant</div>
                <div className="column-subheader-2">
                  We comply with the ujrah and ujrah 'ala al' Amal principles
                  for the subscription of service and service charges for each
                  customer instruction, respectively.
                </div>
              </div>
            </div>
            <div className="link-button-row" style={{ paddingTop: "100px" }}>
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Bulk Payment User Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/Bulk Upload User Guide.pdf"
                  )
                }
              />

              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Account Services User Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/AccountServicesUserGuide.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Payment User Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/PaymentUserGuide.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Customer Service Form
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/CustomerServiceForm.pdf"
                  )
                }
              />
              <LinkButton
                text="FAQ - Cross Border Fund Transfer"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/1611877908_FAQ-CBFT.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> RPP User Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/RPPUserGuide.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Application Form
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/CMS-i Application Form.pdf"
                  )
                }
              />
              <LinkButton
                text="Terms and Conditions"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/1618285438_TC_alrajhicashbiz@24seven.pdf"
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> First Time Activation User
                    Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/FirstTimeActivationUserGuide.pdf"
                  )
                }
              />

              <LinkButton
                text={
                  <span>
                    alrajhicashbiz CMS-<em>i</em> Cross Border Fund Transfer
                    User Guide
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/CMS-iCBFTUserGuide.pdf"
                  )
                }
              />
              <LinkButton
                text="First Time Activation Tutorial Video"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/cashbiz/NEW CMS-i First Time Activation & Soft Token Registration Guideline.mp4 "
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default AlrajhiCashBiz;
